// extracted by mini-css-extract-plugin
module.exports = {"CustomBtn":"CustomBtn_CustomBtn__2bwSf","CustomBtnTxt":"CustomBtn_CustomBtnTxt__1p0ke"};